<template>
  <div class="c-personal-wrapper">
    <!-- filter -->
    <PlannerFilter
      ref="filterRef"
      @custom-col="customColumnModal = true"
      @export="onExportTableData(tableCol, existParams)"
      @change="onQueryAction"
      :export-loading="exportLoading"
    >
      <!-- 设计个人数据，使用日期区间 -->
      <template slot="date">
        <el-radio-group class="date-type-radio" v-model="uploadTimeDateType" @change="onQueryAction">
          <el-radio-button :label="1">日</el-radio-button>
          <el-radio-button :label="2">周</el-radio-button>
          <el-radio-button :label="3">月</el-radio-button>
        </el-radio-group>
        <div style="display: inline-block; margin-left: 8px">
          <DateRangePicker
            v-if="uploadTimeDateType === 1"
            v-model="dateRange"
            style="width: 220px"
            :pickerOptions="{ disabledDate }"
            :clearable="false"
            @change="onQueryAction"
          ></DateRangePicker>

          <dateWeekRange
            v-if="uploadTimeDateType === 2"
            v-model="weekRange"
            range-separator="至"
            style="width: 180px"
            start-placeholder="开始周"
            end-placeholder="结束周"
            :picker-options="weekOptions"
            :clearable="false"
            popper-class="week-range"
            @change="onQueryAction"
          >
          </dateWeekRange>

          <el-date-picker
            v-if="uploadTimeDateType === 3"
            v-model="monthRange"
            :clearable="false"
            type="monthrange"
            value-format="yyyy-MM"
            range-separator="至"
            style="width: 180px"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :picker-options="monthOptions"
            @change="onQueryAction"
          >
          </el-date-picker>
        </div>
      </template>
    </PlannerFilter>

    <!-- table  -->

    <Viewport v-model="tableHeight">
      <el-table
        border
        v-loading="loading"
        class="common-el-table-styles summary-el-table-styles"
        :data="tableData"
        :height="tableHeight"
        :summary-method="tableSummariesMethod"
        show-summary
        @header-dragend="onTableHeaderDragend"
        @sort-change="onSortTable"
        ref="tableRef"
      >
        <el-table-column
          v-for="(col, id) in tableCol"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
          :sortable="col.sortable"
        >
          <template slot-scope="{ row }">
            <span v-if="col.key.indexOf('Rate') > -1">{{ tableRowValueRateToPercent(row, col.key) }}</span>
            <span v-else-if="!['designerName', 'projectGroupName'].includes(col.key)">
              {{ row[col.key] | toThousands }}
            </span>
            <span v-else>{{ row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :total="total"
        :current-page.sync="pageIndex"
        :page-size="pageSize"
        :page-sizes="[10, 20, 30, 40, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="changePageIndex"
        @size-change="changePageSize"
        class="pager"
        background
      />
    </Viewport>

    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      v-model="customColumnModal"
      :name="customColumnName"
      :data="designerColumns"
      :sub-title="['基础信息']"
      @on-select="onTableColsChange"
    />
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import store from '@/store'
import { useRoute } from 'vue-router/composables'
import { designerColumns } from '../data/planner_columns'
import PlannerFilter from './components/planner-filter.vue'
import CustomColumn from '@/components/converter/custom-column2.vue'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import { useDesignerDate } from './hooks/useDesignerDate'
import { useDesignerTable } from './hooks/useDesignerTable'

const route = useRoute()
const filterRef = ref(null)
const tableRef = ref(null)
const tableCustomColsRef = ref(null)

const routeName = computed(() => route.name)
const dataType = computed(() => {
  if (routeName.value === 'designerTeam') return 1
  if (routeName.value === 'staffNew') return 2
  return 0
})
const customColumnName = computed(() => {
  if (routeName.value === 'designerTeam') return 'DesignerDataCustomColumn'
  if (routeName.value === 'staffNew') return 'StaffNewDataCustomColumn'
  return ''
})
const { uploadTimeDateType, dateRange, weekRange, monthRange, weekOptions, monthOptions, disabledDate, getDateRange } = useDesignerDate()
const {
  loading,
  pageIndex,
  pageSize,
  total,
  customColumnModal,
  tableHeight,
  tableData,
  tableCol,
  existParams,
  exportLoading,

  changePageIndex,
  changePageSize,
  onQueryAction,
  onSortTable,
  onExportTableData,
  tableRowValueRateToPercent,
  tableSummariesMethod,
  onTableColsChange
} = useDesignerTable({
  dataType,
  getDateRange,
  buildFilterParams: () => filterRef.value?.buildParams(),
  getToken: () => store.state.token,
  tableRef
})

function onTableHeaderDragend(newWidth, oldWidth, column) {
  tableCustomColsRef.value.updateTableColWidth(newWidth, column)
}
</script>
<style lang="scss" scoped>
.pager {
  text-align: right;
}
</style>
